import { render, staticRenderFns } from "./ConfigurationInfo.vue?vue&type=template&id=5afd55b8&scoped=true&"
import script from "./ConfigurationInfo.vue?vue&type=script&lang=js&"
export * from "./ConfigurationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd55b8",
  null
  
)

export default component.exports